import { jsx as o } from "react/jsx-runtime";
import e from "styled-components";
import i from "../../icons/chevron-down.js";
import r from "../../icons/chevron-right.js";
const n = "treeIconWrapper", p = e.div.withConfig({
  displayName: "IconWrapper"
})([
  "height:24px;width:24px;&:before{content:' ';width:48px;height:32px;background:transparent;position:absolute;left:-24px;top:-4px;}"
]), a = e(i).withConfig({
  displayName: "StyledCollapsedIcon"
})([
  "pointer-events:none;height:24px;width:12px;color:",
  ";"
], ({ theme: t }) => t.text.primary), c = e(r).withConfig({
  displayName: "StyledExpandedIcon"
})([
  "pointer-events:none;height:24px;width:12px;color:",
  ";"
], ({ theme: t }) => t.text.primary), x = () => /* @__PURE__ */ o(p, {
  className: n,
  children: /* @__PURE__ */ o(c, {})
}), m = () => /* @__PURE__ */ o(p, {
  className: n,
  children: /* @__PURE__ */ o(a, {})
});
export {
  m as CollapseIcon,
  x as ExpandIcon,
  p as IconWrapper,
  n as TREE_ICON_WRAPPER_CLASS
};
